module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta-title":"Winerz  |  Maintenance","maintenance-intro":"Winerz is actually in maintenance mode.<br /><br />Please come back later, launch is officially on Oct. 13th"},"fr":{"meta-title":"Winerz  |  Maintenance","maintenance-intro":"Winerz est actuellement en maintenance.<br /><br />Reviens plus tard, lancement officiel prévu le 13 Octobre."}}')
  delete Component.options._Ctor
}
